import React from 'react';
import { wasteTypes } from '../data/mock';
import { Button } from './ui/button';

const WasteTypes = () => {
  const scrollToContact = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="bins" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-blue-600 font-semibold tracking-wider uppercase text-sm">Our Pricing</span>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#1a365d] mt-4 mb-6">
            Bin Rental <span className="text-blue-500">Pricing</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Transparent pricing with no hidden fees. Choose the bin that fits your project needs.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {wasteTypes.map((waste) => (
            <div
              key={waste.id}
              className="bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={waste.image}
                  alt={waste.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <span className="text-xs text-white/80 uppercase tracking-wider block mb-1">
                    {waste.category}
                  </span>
                  <h3 className="text-xl font-bold text-white">{waste.title}</h3>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-baseline justify-between mb-4">
                  <div>
                    <span className="text-sm text-gray-500">Starting at</span>
                    <div className="text-3xl font-bold text-[#1a365d]">${waste.startingPrice}</div>
                  </div>
                  <span className="text-xs text-blue-600 bg-blue-50 px-3 py-1 rounded-full">
                    {waste.sizes.length} sizes
                  </span>
                </div>

                <p className="text-sm text-gray-500 mb-4">{waste.note}</p>

                <Button
                  onClick={scrollToContact}
                  className="w-full bg-[#1a365d] hover:bg-[#2d4a7c] text-white font-semibold transition-all duration-300"
                >
                  Get Quote
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Info */}
        <div className="mt-12 bg-blue-50 rounded-2xl p-8 text-center">
          <p className="text-gray-700 mb-4">
            <span className="font-semibold">All prices include:</span> Delivery, 7-day rental, pickup, and disposal within weight limits.
          </p>
          <p className="text-sm text-gray-500">
            Need a custom quote or have questions? Give us a call at <span className="font-semibold">(905) 595-6987</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default WasteTypes;
